/* eslint max-len: "off", comma-dangle: "off", quote-props: "off" */
export default {
  pt: {
    home: 'início',
    Home: 'Início',
    'change language': 'alterar idioma',
    login: 'login',
    register: 'registo',
    suppliers: 'promotores',
    'Supplier': 'Promotor',
    'Discover the natural wonders of Portugal': 'Descubra os encantos naturais de Portugal',
    'Book your tours, adventure activities or nature watching': 'Reserve os seus passeios, atividades de aventura ou observação da natureza',
    Location: 'Local',
    'settings': 'dados de conta',
    'What to do': 'O que fazer',
    From: 'De',
    To: 'Até',
    'soon in more locations': 'brevemente em mais localizações',
    'logout': 'sair',

    'What others are saying': 'O que dizem sobre nós',
    'Yes': 'Sim',

    // supplier Registration
    'Supplier Registration': 'Registo de Promotor',
    'Company Name': 'Denominação Social',
    'First Name': 'Nome Próprio',
    'Last Name': 'Apelido',
    'Password Confirmation': 'Confirmação da Password',
    'Already a member?': 'Já está registado?',

    'You must provide a company name': 'É necessário um nome de empresa',
    'You must provide a NIPC number': 'É necessário fornecer um NIPC',
    'You must provide a RNAAT number': 'É necessário fornecer um número de RNAAT',
    'The username field is required.': 'É necessário um nome de utilizador',
    'A username must contain only characters from A-Z, 0-9 and dashes': 'O nome de utilizador só pode conter caracteres de A-Z, 0-9 e traços',
    'Website must be a valid url (https://example.org)': 'Website tem de ser um endereço válido (https://example.org)',
    'You must provide a postal code': 'É necessário fornecer um código postal',
    'A username must contain only characters from A-Z, 0-9 and dashes.': 'O nome de utilizador só pode conter caracteres de A-Z, 0-9 e traços',
    'You must provide a first name': 'É necessário um nome próprio',
    'You must provide a last name': 'É necessário um apelido',
    'You must provide an email': 'É necessário um endereço de email',
    'You must provide a password': 'Tem de fornecer uma password',
    'You must provide a phone number': 'É necessário um número de telefone',
    'This must be a valid e-mail': 'Tem de inserir um email válido',
    'The email you provided is not valid': 'Este endereço de email não é válido',
    'This email is already registered.': 'Este endereço de email já está registado',
    'You are not supposed to try to change this value': 'Não é suposto tentar mudar este valor manualmente',
    'You must provide a password.': 'É necessária uma password',
    'Your password must contain at least 6 characters.':
    'A password deve ter no mínimo 6 caracteres',
    'Your password should contain at least a number and an uppercase letter.': 'A password deve ter pelo menos um número e uma letra maiúscula',
    'Your passwords didn\'t match. Please try again': 'As passwords não correspondem. Por favor tente de novo.',

    Register: 'Registar',
    Recover: 'Recuperar',

    Registration: 'Registo',
    'Thank you for registering': 'Obrigado pelo seu registo',
    'Booknatura administration will verify and confirm your registration request.': 'Os administradores da plataforma irão confirmar o seu pedido de registo.',
    'You should be receiving an account activation email shortly': 'Brevemente receberá um email para ativar a sua conta.',

    'Email has been confirmed': 'O email foi confirmado',
    'Your account is now active': 'A sua conta está agora ativa',
    'Email or username': 'Email ou nome de utilizador',
    'Your session has expired. Please confirm that you\'re still with us.': 'A sua sessão expirou. Por favor confirme que ainda está connosco.',
    'The Booknatura administration have not approved your account yet. If you need further assistance please contact info@booknatura.com': 'A administração de Booknatura ainda não aprovou a sua conta. Caso necessite de assistência contacte-nos através de info@booknatura.com',
    'You still haven\'t activated your account. Please check your email for activation instructions. If you need further assistance please contact info@booknatura.com': 'Ainda não ativou a sua conta. Por favor verifique o seu email para instruções para ativação. Caso necessite de ajuda contacte-nos através de info@booknatura.com',
    'Thank you.': 'Obrigado.',
    'Are you a supplier and don\'t have an account yet?': 'É um promotor e ainda não tem uma conta?',
    'Don\'t have an account yet?': 'Ainda não tem uma conta?',
    'Forgot your password?': 'Esqueceu-se da sua palavra-passe?',
    'Email/username or password don\'t match an account': 'Email/nome de utilizador ou palavra-passe não correspondem a uma conta',
    'You must fill the username/email and password fields': 'Tem de preencher os campos de nome de utilizador/email e palavra-passe',
    'Recover password': 'Recuperar palavra-passe',
    'Continue': 'Continuar',
    'Remembered the password?': 'Lembrou-se da palavra-passe?',
    'User does not exist': 'O utilizador não existe',
    'Not a valid username or email': 'Não é um email ou nome de utilizador válido.',
    'Help is on the way': 'A ajuda está a caminho',
    'Check your email for instructions on how to recover your account':
    'Foi enviado um email com instruções para recuperar a sua conta.',
    'Reset password': 'Alterar palavra-passe',
    'Please insert your new password': 'Por favor insira a sua nova palavra-passe',
    'Current password': 'Palavra-passe atual',
    'New password': 'Nova palavra-passe',
    'Repeat password': 'Repita a palavra-passe',
    'Change password': 'Alterar palavra-passe',
    'Your password must contain at least 6 characters':
    'A sua palavra-passe deve conter pelo menos 6 caracteres',
    'Your password should contain at least a number and an uppercase letter': 'A sua palavra-passe deve conter um número e uma letra maiúscula',
    'New password saved': 'Nova palavra-passe guardada',
    'Your password has been saved.': 'A sua palavra-passe foi guardada.',
    'This is not your current password': 'Esta não é a sua palavra-passe atual',

    // supplier Dashboard
    'Pending bookings': 'Reservas pendentes',
    'Top activities': 'Atividades principais',
    'You don\'t have any activities yet': 'Ainda não tem atividades',
    '(translation not available)': '(tradução não disponível)',

    // supplier Settings
    'please accept the terms of use before continuing': 'Por favor aceite os termos de utilização antes de continuar',
    'Company Information': 'Dados da empresa',
    'Person to contact': 'Pessoa de contacto',

    'Company name': 'Denominação social',
    'Company brand name': 'Nome da empresa/marca',
    'RNAAT number': 'Número RNAAT',
    'Head office': 'Endereço da sede',
    'Company id number': 'Número de identificação de pessoa coletiva',
    'Zip code': 'Código postal',
    'First name': 'Nome próprio',
    'Last name': 'Apelido',
    'Nationality': 'Nacionalidade',
    'Country of residency': 'País de residência',
    'Phone number': 'Número de telefone',
    'Payment method': 'Método de pagamento',
    'Payment Processing Entity': 'Entidade de processamento de pagamentos',
    'If the payments to the Supplier are cumulatively higher than € 1000 per year, the Supplier must provide to the Payment Processing Entity the following documents so that the latter can process and transfer the money:': 'Se os pagamentos a realizar ao Promotor forem superiores cumulativamente a 1000€ por ano, o Promotor terá de disponibilizar à Entidade de Processamento de Pagamentos os seguintes documentos para que esta possa processar e transferir o dinheiro:',
    'Trade Registration Certificate': 'Certidão do Registo de Comércio',
    'Articles of Association': 'Estatutos / Contrato da sociedade',
    'Proof of identification of the Legal Representative': 'Prova de identificação do Representante Legal',
    'Statement of shareholders': 'Declaração de acionistas',
    'template': 'minuta',
    'Document upload location available soon': 'Local para upload dos documentos disponível brevemente',

    'Do you want Booknatura to handle the payments for you or just charges its commission?': 'Prefere que Booknatura trate dos pagamentos ou que cobre apenas a sua comissão?',
    'Handle payments for me': 'Trate dos pagamentos por mim',
    'Only charge commissions': 'Cobre somente comissões',
    'List the payment methods that you accept at the activity location': 'Indique os métodos de pagamento que disponibiliza ao cliente no local da atividade',
    'Money': 'Numerário',
    'Debit card': 'Cartão de débito',
    'Credit card': 'Cartão de crédito',
    'Which credit cards do you accept?': 'Quais os cartões de crédito que aceita?',
    'Other payments': 'Outros pagamentos',
    'You have to specify which credit cards you accept': 'Tem de indicar quais os cartões de crédito que aceita',
    'What other payments do you accept': 'Que outras formas de pagamento aceita',
    'yyyy/mm/dd': 'aaaa/mm/dd',

    'Legal Representative': 'Representante Legal',
    'When it is necessary the intervention of more than one legal representative to compel the company please indicate the data of all representatives:': 'Quando é necessário a intervenção de mais do que um representante legal para obrigar a sociedade por favor indique os dados de todos os representantes:',
    'Id card number': 'Número de cartão de cidadão',
    'Birth date': 'Data de Nascimento',
    'Add another': 'Adicionar outro',

    'You must provide an id card number': 'Tem de fornecer o número de identificação',
    'You must provide the nationality': 'Tem de fornecer a nacionalidade',
    'You must provide the country of residence': 'Tem de fornecer o país de residência',
    'You must provide and email': 'Tem de fornecer um email',
    'You must provide the birth date': 'Tem de fornecer a data de nascimento',
    'You must provide the birth date in the format YYYY-MM-DD': 'Tem de fornecer a data de nascimento no formato AAAA-MM-DD',
    'This must be a valid email': 'Tem de ser um email válido',
    'YYYY-MM-DD': 'AAAA-MM-DD',
    'You must select one of the payment options': 'Tem de selecionar um dos métodos de pagamento',

    'Do you accept our': 'Aceita os nossos',
    'I have read and accept': 'Li e aceito',
    'I have read and accept the': 'Li e aceito os',
    'and the': 'e o',
    'You have to accept the General Terms of Service to continue': 'Tem de aceitar os Termos Gerais de Prestação de Serviços para continuar',
    'You have to accept the terms to continue': 'Tem de aceitar os termos para continuar',
    'You will receive shortly by mail the General Terms of Service for signature by the legal representative(s)': 'Brevemente irá receber por correio os Termos Gerais de Prestação de Serviços para assinatura pelo(s) representante(s) legais',

    'Our recomendations': 'As nossas recomendações',
    'from': 'a partir de',
    'group': 'grupo',
    'Group activity': 'Atividade de grupo',
    'Available times for': 'Horários disponíveis para',
    'Available time for': 'Horário disponível para',
    'Allows instant booking': 'Permite confirmação imediata',
    'Minimum age': 'Idade mínima',
    'Allows any age': 'Aceita todas as idades',
    'The activity is available for': 'Há disponibilidade para',
    'at the selected time': 'no horário selecionado',
    'Activity recognized as Nature Tourism': 'Atividade reconhecida como Turismo de Natureza',
    'Free cancellation': 'Pode cancelar a sua reserva gratuitamente até',
    'in advance.': 'antes da data da atividade.',
    'Do you have special prices for children? Insert maximum age for discount': 'Tem preços especiais para crianças? Indique a idade limite para o desconto',
    'years old': 'anos',
    'duration': 'duração',
    'day': 'dia',
    'days': 'dias',
    'hours': 'horas',
    'min': 'min',
    'Base price (€)': 'Preço base (€)',
    'Enter the most common price for this activity': 'Insira o preço mais comum desta atividade',
    'ex: In a boat trip, do you charge for each participant or for the boat trip?': 'ex: Numa viagem de barco o valor cobrado é por cada participante ou pela viagem de barco?',
    'The price is calculated per participant': 'O preço é calculado por cada participante',
    'The price is calculated per activity occurrence': 'O preço é calculado por ocorrência da atividade',

    'Is recognized as a Nature Tourism activity': 'Atividade reconhecida como Turismo de Natureza',
    'Is low mobility accessible': 'Atividade acessível a pessoas com mobilidade reduzida',
    'Accessible to low mobility people': 'Acessível a pessoas com mobilidade reduzida',

    'Minimum and Maximum group sizes for the activity to take place': 'Número mínimo e máximo de participantes para a realização da atividade ',
    'minimum': 'mínimo',
    'maximum': 'máximo',
    'What\'s included': 'O que está incluído',
    'Aditional services': 'Serviços adicionais',
    'Housing, transport, etc': 'Alojamento, transporte, etc',
    Rules: 'Regras',
    Reviews: 'Críticas',
    'Average rating': 'Pontuação média',
    Calendar: 'Calendário',
    adult: 'adulto',
    children: 'crianças',
    adults: 'adultos',
    'person': 'pessoa',
    'persons': 'pessoas',
    'participant': 'participante',
    'participants': 'participantes',
    child: 'criança',
    'Book now': 'Reservar agora',
    'You have': 'Tem',
    bookings: 'reservas',
    'waiting for approval': 'a aguardar aprovação',
    'Waiting for images': 'Aguarda imagens',
    'Review bookings': 'Rever reservas',
    'View full calendar': 'Ver calendário',
    'View all activities': 'Ver todas as atividades',
    'View payments': 'Ver pagamentos',
    Account: 'Conta',
    'Instant booking': 'Reserva imediata',
    'Account details': 'Detalhes de conta',
    'Account settings': 'Definições da conta',
    Enabled: 'Ativada',
    Disabled: 'Desativada',
    'Need help?': 'Precisa de ajuda?',
    'Check the Suplier Guide': 'Consulte o Guia do Promotor',
    'or contact us via': 'ou contacte-nos através de',
    'contact button': 'botão de contacto',
    'A booking platform': 'Plataforma de reservas',
    'for nature activities': 'de atividades ao ar livre',
    'Search by location and date': 'Pesquise por localização e data',
    'Allows easy and fast bookings': 'Reservas fáceis e intuitivas',
    'Accepts multiple payment methods': 'Aceita vários métodos de pagamento',
    'Register as a supplier': 'Registo como Promotor',


    'Increase your Bookings': 'Aumente as suas reservas',
    'Higher visibility for your activities in the national and international market': 'Maior visibilidade para as suas atividades no mercado nacional e internacional',
    'Enables instant confirmation of bookings': 'Possibilita confirmação instantânea de reservas',
    'Ensure a flawless experience for your customers': 'Assegure uma experiência sem falhas aos seus clientes',

    'Save time and money': 'Poupe tempo e dinheiro',
    'Free access to management software': 'Acesso gratuito a software de gestão',
    'Simple management of your bookings through your computer or smartphone': 'Gestão simples e rápida das suas reservas através do seu computador ou smartphone',
    'Add or edit your activities whenever necessary': 'Adicione e altere as suas atividades sempre que necessário',

    'No fees or subscription': 'Sem taxas ou subscrições',
    'Pay only a commission for bookings made through the platform': 'Pague apenas uma comissão pelas reservas realizadas',

    'Share our vision': 'Partilhe da nossa visão',
    'We believe that all those who practice or organize tourism activities in nature should promote respect for the natural heritage and contribute to its conservation.': 'Acreditamos que todos os que praticam ou organizam atividades turísticas na natureza devem promover o respeito pelo património natural e contribuir para a sua conservação.',
    'Booknatura is designed to clients who enjoy contact with nature and seek more active, authentic and sustainable experiences.': 'Booknatura está direcionada para clientes que gostam do contacto com a natureza e procuram experiências mais ativas, autênticas e sustentáveis.',

    'Join us': 'Junte-se a nós',
    'or': 'ou',
    'contact us': 'entre em contato',


    'How does it work': 'Como funciona',
    'Search by location, activity or date': 'Pesquise por localização, atividade ou data',
    Search: 'Pesquise',
    Book: 'Reserve',
    Enjoy: 'Disfrute',
    'Get in touch with nature through unique activities': 'Contacte com a natureza através de atividades únicas',

    // supplier SubMenu
    Dashboard: 'Geral',
    Activities: 'Atividades',
    Bookings: 'Reservas',
    Payments: 'Pagamentos',

    // supplier Activities
    'Almost starting!': 'Está quase a começar!',
    'Create your first activity': 'Criar a sua primeira atividade',
    'Add new activity': 'Adicionar nova atividade',
    'Activity successfully removida': 'Atividade removida',
    'Waiting Approval': 'Aguarda Aprovação',
    Name: 'Nome',
    Rating: 'Classificação',
    Duration: 'Duração',
    view: 'ver',
    edit: 'editar',
    remove: 'remover',
    Removing: 'remover',
    photos: 'fotografias',

    // supplier Add Activity

    // field names
    'Activity name (Portuguese)': 'Nome da atividade (Português)',
    'Activity name (English)': 'Nome da atividade (Inglês)',
    'Description (Portuguese)': 'Descrição (Português)',
    'Description (English)': 'Descrição (Inglês)',
    'What\'s included (Portuguese)': 'O que está incluído (Português)',
    'What\'s included (English)': 'O que está incluído (Inglês)',
    'Guide (Portuguese)': 'Guia (Português)',
    'Guide (English)': 'Guia (Inglês)',
    'Aditional services (Portuguese)': 'Serviços adicionais (Português)',
    'Aditional services (English)': 'Serviços adicionais (Inglês)',
    'Do you have any aditional question for the client (Portuguese)': 'Tem alguma questão adicional para o cliente (Português)',
    'Do you have any aditional question for the client (English)': 'Tem alguma questão adicional para o cliente (Inglês)',
    'Please indicate any request to the client of specific information required to organize the activity, such as weight and height of participants': 'Por favor indique algum pedido de informação específico a fazer ao cliente necessário para a organização da atividade como, por exemplo, peso e altura dos participantes',
    'Do not forget (Portuguese)': 'A não esquecer (Português)',
    'Do not forget (English)': 'A não esquecer (Inglês)',

    'Cancelation policy': 'Política de cancelamento',
    'Free cancelation of the booking until': 'Cancelamento gratuito da reserva até',
    'before the activity date': 'antes da data da atividade',
    'Basic Information': 'Informação básica',
    'Photos': 'Fotografias',
    'Description': 'Descrição',
    'Describe the activity in one or two paragraphs listing what the participants will do and the activity highlights. Classify the activity as easy, medium or hard and indicate if any person can do it or some physical preparation will be necessary.': 'Descreva em um ou dois parágrafos a atividade indicando o que os participantes vão fazer e quais os seus principais destaques. Classifique a atividade como fácil, moderada ou difícil e se é indicada para qualquer pessoa ou se é necessária alguma preparação física.',
    'List everything that is included in the price like, gear, insurance, meals/snack, etc': 'Indique tudo o que está incluído no preço, como por exemplo, material, seguros, refeições/snacks, etc',
    'This message will only be shown in the client voucher. List the most important rules of the activity, like security rules, and add some brief description of the items that participants should carry like snacks, sunscreen, towels, bathing suit, comfortable clothing etc': 'Esta mensagem aparecerá apenas no voucher para o cliente. Indique quais as principais regras da atividade, como regras de segurança, e aproveite para dar algumas notas breves sobre o que os participantes deverão levar para o local como um snack, protetor solar, toalha de praia, fato de banho, roupa prática, etc',
    'Allow instant booking': 'Permite reserva imediata',
    'How many days before an activity can a booking be canceled': 'Quantos dias antes da atividade pode ser cancelada uma reserva',
    'Meeting Point': 'Ponto de encontro',
    'Please select a point in the map or enter the geographical coordinates': 'Por favor selecione o local do ponto de encontro no mapa ou indique as coordenadas geográficas',
    'Spoken languages by the activity guide': 'Línguas faladas pelo guia',
    'Latitude': 'Latitude',
    'Longitude': 'Longitude',
    'District': 'Distrito',
    'None': 'Nenhum',
    'Municipality': 'Município',
    'City / Village': 'Cidade / Vila / Povoação',
    'Are any of the following places related to your activity?': 'Alguns dos seguintes lugares estão relacionados com a sua atividades?',
    'Address': 'Endereço',
    'City': 'Cidade',
    'Activity Location': 'Localização da atividade',
    'Related Locations': 'Localizações relacionadas',
    'Categories': 'Categorias',
    // 'Pick the categories that best fit your activity': 'Escolha as categorias que melhor se enquadram na sua atividade',
    'Protected Areas': 'Áreas Protegidas',
    'River': 'Rio',
    'Mountain': 'Montanha',
    'Rivers': 'Rios',
    'Mountains': 'Montanhas',
    'Other locations': 'Outros locais',
    'Aditional information': 'Informação adicional',
    'Extra information from the client': 'Pedido de informação adicional ao cliente',
    'Voucher information': 'Informação para voucher',
    'Booking confirmation': 'Confirmação da reserva',

    'Free cancellation until': 'Cancelamento gratuito da reserva até',
    'before the activity': 'antes da data da atividade',

    'You must provide a location': 'Tem de fornecer uma localização',
    'Duration must be a number': 'Duração tem de ser um número',
    'Field must be either yes or no': 'Campo tem de ser Sim ou Não',
    'Minimum age must be a number': 'A idade mínima tem de ser um número',
    'The maximum number of participants must be bigger than the minimum': 'O número máximo de participantes tem de ser maior que o mínimo',
    'Age must be a positive number': 'A idade tem de ser um número positivo',
    'The minimum cancelation days is 0': 'O valor mínimo são 0 dias',
    'The price must be a positive number': 'O preço tem de ser um valor positivo',
    'You must provide an address': 'Tem de fornecer uma morada',
    'You must provide a valid address': 'Tem de fornecer uma morada válida',
    'You must provide a city': 'Tem de fornecer uma cidade',
    'You must provide a city_id': 'Tem de fornecer uma cidade',
    'Longitude must be a number': 'A longitude tem de ser um número',
    'Latidude must be a number': 'A latitude tem de ser um número',
    'Published must be yes or no': 'Tem de escolher se quer ou não publicar a atividade',
    'Choose at least one category': 'Escolha pelo menos uma categoria',
    'You must provide at least one category': 'Tem de escolher pelo menos uma categoria',
    'You must provide a list of categories': 'Tem de fornecer uma lista de categorias',
    'The chosen option does not correspond to a category': 'A opção escolhida não corresponde a uma categoria válida',
    'You must provide an activity name at least in one language': 'Tem de fornecer o nome da atividade pelo menos num idioma',
    'You must provide an activity name in this language if you provide a description': 'É necessário fornecer o nome da atividade neste idioma se forneceu uma descrição',
    'You must provide a description at least in one language': 'Tem de fornecer uma descrição em pelo menos um idioma',
    'You must provide a duration': 'Tem de fornecer uma duração',
    'You must provide a base price': 'Tem de fornecer um preço base',
    'Latitude can\'t be 0': 'A latitude não pode ser 0',
    'Longitude can\'t be 0': 'A longitude não pode ser 0',
    'What\'s included must receive a valid text': 'O que está incluído deve ser um texto válido',
    'Aditional Services must be a valid text': 'Serviços adicionais deve ser um texto válido',
    'Rules must be a valid text': 'Regras devem ser um texto válido',
    'You must provide the spoken languages available for the activity': 'Tem de indicar as línguas faladas na atividade',

    'You must provide an activity description if you provide a name': 'Se fornece um nome para a atividade neste idioma também tem de fornecer uma descrição',
    'You must provide the days where a cancelation is possible': 'Tem de fornecer o número de dias',

    'I think we\'re ready': 'Parece-me que estamos prontos',
    'Complete activity insertion by adding some photos': 'Complete a inserção da atividade adicionando as fotografias',
    'Save and go back': 'Guardar e voltar atrás',


    // Activity Images
    'Images for': 'Imagens para',
    'We suggest 3 to 5 images that clearly portray your activity': 'Sugerimos 3 a 5 imagens representativas da atividade',
    'Images should be in jpeg format with dimensions between 600 and 10000 pixels': 'As imagens devem ser em formato jpeg com dimensões entre 600 e 10000 pixels.',
    'For visually impaired users': 'Para utilizadores com deficiência visual',
    'drop images here': 'Arraste imagens para aqui',
    'uploading images': 'a enviar imagens',
    'or search in your computer...': 'ou pesquise no seu computador...',
    'The image must be an image': 'Tem de ser uma imagem',
    'The image must be between 600 and 10000 pixels wide and between 600 and 10000 pixels tall.': 'A imagem deve ter entre 600px a 10000px de altura e 600px a 10000px de altura',

    'Save and go to photos': 'Guardar e ir para as fotografias',

    'The image must be an image.': 'Tem de fornecer uma imagem',
    // supplier add images
    'Title (Portuguese)': 'Título (Português)',
    'Title (English)': 'Título (Inglês)',
    'Photos for': 'Fotografias para',
    'You must provide a photo': 'Tem de fornecer uma fotografia',
    'The photo must be either a jpeg or a png.': 'A fotografia deve ter o formato jpeg ou png',
    'Photo dimensions must allway be bigger than 300px and smaller than 5000px.': 'As dimensões da fotografia têm de ser maiores que 300px e menores que 5000px',
    'Back to Activity List': 'Voltar à listagem de atividades',
    'Set Activity Calendar': 'Definir o calendário da atividade',

    'Your activity is now queued for review.': 'A sua atividade foi enviada para aprovação',
    'In the mean time you can set your activity calendar.': 'Enquanto aguarda pode já começar a definir o calendário',
    // supplier CALENDAR
    'Pick a day in the calendar to schedule a new activity': 'Escolha um dia no calendário para agendar uma nova atividade',
    'Edit event': 'Alterar ocorrência',
    'Edit all repetitions': 'Alterar todas as repetições',
    'Select an activity': 'Selecione uma atividade',
    'change activity': 'alterar atividade',
    'Does not repeat': 'Sem repetições',
    'Repeats Weekly': 'Semanalmente',
    'Repeats Monthly': 'Mensalmente',
    'Start date': 'Data de início',
    'Time': 'Hora',
    'Choose the repeating weekdays': 'Escolha os dias em que a atividade se repete',
    'Clear Selection': 'Limpar seleção',
    'Select All': 'Selecionar todos',
    'During the month repeat': 'Durante o mês repete',
    'every week': 'todas as semanas',
    'every 1st week of the month': 'A cada 1ª semana do mês',
    'every 2nd week of the month': 'A cada 2ª semana do mês',
    'every 3rd week of the month': 'A cada 3ª semana do mês',
    'every 4th week of the month': 'A cada 4ª semana do mês',
    'every 5th week of the month': 'A cada 5ª semana do mês',
    'Pick the repeating days of the month': 'Indique os dias do mês',
    'Repeat forever?': 'Repetir indeterminadamente?',
    'yes': 'sim',
    'no': 'não',
    'Availability': 'Disponibilidade',
    'You must provide an availability': 'Tem de indicar uma disponibilidade',
    'Price (€)': 'Preço (€)',
    'Price per group (€)': 'Preço por grupo (€)',
    'Youth Price (€)': 'Preço para crianças (€)',
    'Why are you canceling this activity?': 'Porque está a cancelar esta ocorrência?',
    'Go Back': 'Voltar Atrás',
    'Remove': 'Remover',
    'Stop repeating at': 'Parar repetições em:',
    'Cancel Activity': 'Cancelar Atividade',
    'Save': 'Guardar',
    'Sun': 'Dom',
    'Mon': 'Seg',
    'Tue': 'Ter',
    'Wed': 'Qua',
    'Thu': 'Qui',
    'Fri': 'Sex',
    'Sat': 'Sáb',
    'You must provide at least one day of the week': 'Tem de escolher pelo menos um dia da semana',
    'You must choose at least one day of the month': 'Tem de escolher pelo menos um dia do mês',

    // Search
    'Sorry no activities were found for your search query.': 'Não foram encontradas atividades para a sua pesquisa.',

    // Admin
    'Users': 'Utilizadores',

    'Availability must be a positive number': 'Disponibilidade tem de ser um número positivo',
    'Hour has to be a number between 0 and 23': 'Hora tem de ser um valor entre 0 e 23',
    'Minutes must be a number between 0 and 59': 'Minutos têm de ser um número entre 0 e 59',
    'You must provide the minutes': 'Tem de inserir os minutos',
    'You must provide the minutes. Format (HH:MM)': 'Tem de inserir os minutos. Formato (HH:MM)',
    'The start date must be a date': 'A data e hora de início tem de ser válida',
    'The end date must be a date': 'A data de fim tem de ser válida',
    'The start date cannot be older than today': 'A data de início não pode ser anterior ao dia de hoje',
    'Start time': 'Hora de início',
    'You must provide an hour': 'Tem de fornecer uma hora',
    'You must provide a price': 'Tem de indicar um preço',
    'Price must be a positive number above 0': 'O preço tem de ser um número positivo superior a 0',
    'Price must be a number': 'O preço tem de ser um número',
    'Youth discount price must be a positive number': 'Preço para crianças deve ser um número positivo',

    // Footer
    'General Terms of Service': 'Termos Gerais de Prestação de Serviços',
    'Framework Contract of the Payment Processing Entity': 'Contrato dos Serviços da Entidade de Processamento de Pagamentos',

    // Activity
    'Activity not found': 'Atividade não encontrada',
    'Sorry, the activity you were looking for was not found.': 'Desculpe, a atividade que procurava não foi encontrada',
    'Return to the Homepage': 'Voltar à página inicial',
    'Translation not Available': 'Tradução não disponível',
    'There\'s not yet an available translation for this activity.': 'Ainda não há uma tradução disponível para esta atividade.',
    'Change language or search for another activity.': 'Altere a língua ou procure outra atividade',
    'The Supplier contacts are shown on the voucher you will receive after the booking confirmation': 'Os contactos do Promotor são indicados no voucher que irá receber após a confirmação de reserva.',
    'All booking information including supplier data and meeting point are included in your booking confirmation voucher.': 'As informações da reserva, incluindo dados do promotor e ponto de encontro, são disponibilizadas no voucher de confirmação de reserva.',
    'Please select a day': 'Selecione um dia',

    // Categories
    'Sports and Adventure': 'Desporto e aventura',
    'Tours': 'Passeios',
    'Nature Watching': 'Observação da Natureza',
    'Land': 'Terra',
    'Water': 'Água',
    'Air': 'Ar',

    'Arborism': 'Arborismo',
    'Snow sports': 'Desportos de neve',
    'Climbing': 'Escalada',
    'Caving': 'Espeleologia',
    'Geocaching': 'Geocaching',
    'Mountaineering': 'Montanhismo',
    'Orienteering': 'Orientação',
    'Ropes and bridges': 'Cordas - pontes',
    'Rappel': 'Rappel',
    'Pendular jump / Bungee jumping': 'Salto pendular / Bungee jumping',
    'Slide': 'Slide',
    'Bodyboard': 'Bodyboard',
    'Canyoning': 'Canyoning',
    'Coasteering': 'Coasteering',
    'Hidrospeed ': 'Hidrospeed',
    'Kitesurf': 'Kitesurf',
    'Diving': 'Mergulho',
    'Fishing': 'Pesca turística',
    'Rafting': 'Rafting',
    'Water skiing / Wakeboard': 'Ski aquático / Wakeboard',
    'Snorkeling': 'Snorkeling',
    'Standup paddle boarding (SUP)': 'Standup paddle boarding (SUP)',
    'Surf': 'Surf',
    'Sailing': 'Vela',
    'Windsurf': 'Windsurf',
    'Hang gliding': 'Asa delta',
    'Ballooning': 'Balonismo',
    'Paramotor': 'Paramotor',
    'Paragliding': 'Parapente',
    'Tandem jump': 'Salto tandem',
    'Ultralight': 'Ultraleve',
    'Hiking': 'Caminhadas',
    'Fotography': 'Fotografia',
    'Bike tours': 'Passeios de bicicleta',
    'Mountain biking': 'BTT',
    'Segway tours': 'Passeios de segway',
    'Horse riding': 'Passeios a cavalo',
    'Carriage tour': 'Passeios em atrelagens de tração animal',
    'Donkey rides': 'Passeios de burro',
    'Moto tours': 'Passeios de moto',
    'Off-road tours': 'Passeios em veículos todo-o-terreno',
    'Car/van tours': 'Passeios em carro/carrinha',
    'Aquatic hiking': 'Caminhadas aquáticas',
    'Boat tours': 'Passeios de barco',
    'Canoeing': 'Canoagem',
    'Fauna watching': 'Observação de fauna',
    'Birdwatching': 'Observação de aves',
    'Dolphin watching': 'Observação de golfinhos e outros animais marinhos',
    'Flora watching': 'Observação de flora',

    // User Registration
    'User Registration': 'Registo de Utilizador',
    'Are you a supplier?': 'É um promotor?',
    'Username': 'Nome de Utilizador',
    'The username has already been taken.': 'Este nome de utilizador já está registado',
    'This email is already registered': 'Esta conta de email já está registada',
    'Are you an adventurer and not a supplier?': 'É um aventureiro e não um promotor?',
    'Register as a user': 'Registe-se como utilizador',
    'Go to last visited activity': 'Ir para a última atividade visitada',

    // Page Titles
    'Suppliers': 'Promotores',
    'Supplier Dashboard': 'Painel de Controlo dos promotores',
    'Email Validation': 'Validação de email',
    'Supplier Activities': 'Atividades do Promotor',
    'Add Activity': 'Adicionar Atividade',
    'Edit Activity': 'Editar Atividade',
    'Terms of Use': 'Termos de Utilização',
    'Images': 'Imagens',
    'Supplier Settings': 'Definições do Promotor',
    'Activity': 'Atividade',
    'Booking': 'Reservas',
    'My Bookings': 'As minhas Reservas',
    'Registration Success': 'Registo efetuado com sucesso',
    'Account Recovery': 'Recuperação de conta',

    'Admin Dashboard': 'Painel de Controlo de Administração',
    'Admin Activities': 'Administradores, Atividades',
    'admin users': 'Administradores, utilizadores',


    // your Bookings
    'Will be charged': 'Será cobrada',
    'Has been charged': 'Foi cobrada',
    'Will not be charged': 'Não será cobrada',
    'Persons': 'Pessoas',
    'Date': 'Data',
    'Canceled': 'Cancelada',
    'Waiting': 'Em espera',
    'Confirmed': 'Confirmada',
    'Refused': 'Recusada',
    // Voucher
    'You can only set how the activity is priced on creation': 'Só pode definir como é cobrada a atividade durante a criação da mesma',
    'Suppliers cannot book activities. If you want to book an activity please register a personal account': 'Os promotores não podem reservar atividade. Registe uma conta pessoal para reservar atividades.',
    'The payment to the supplier will be made directly on the listed time and place for the activity, either to the guide or to a supplier representative.': 'O pagamento a efetuar ao promotor será realizado no dia e local da atividade ao guia ou representante do promotor presente.',

    'You are in the booking page but haven\'t selected an activity yet': 'Está na página de reserva mas ainda não escolheu uma atividade',
    'You are in the booking page for an activity that does not exist': 'Está na página de reserva de uma atividade que não existe',

    'Respect nature during your activity': 'Respeite a Natureza durante a sua atividade',
    'Take only memories, leave only footprints': 'Leve apenas as suas memórias, deixe apenas as suas pegadas',
    'Do not litter – Keep your garbage until you find a trash bin': 'Guarde e deposite o seu lixo em local apropriado',
    'Only start a fire in an authorized area': 'Só faça lume nos locais autorizados para o efeito',
    'Avoid unnecessary noise, specially in shelter or breeding areas': 'Evite fazer ruído, especialmente em locais de abrigo e reprodução',
    'Do not feed the animals': 'Não alimente os animais',
    // Voucher
    'Do not take animals, plants or geological samples': 'Não recolha animais, plantas ou amostras geológicas',
    'Respect all signboards': 'Toda a sinalização deve ser respeitada',
    'Follow all rules and guidelines from the activity guides': 'Siga todas as regras e indicações dos guias',
    'Respect the locals, their culture and traditions': 'Respeite as populações locais, a sua cultura e tradições',

    'I agree with the booking conditions': 'Ao reservar esta atividade, concordo com as condições de reserva da atividade',
    'and privacy policy by booking this activity': 'e a política de privacidade',
    'Confirm booking and go to payment': 'Confirmar reserva e ir para o pagamento',
    'Make a booking and wait for a confirmation.': 'Efectue a reserva e aguarde a confirmação.',
    'Booked by': 'Reservado por',
    'Payment information': 'Informação de pagamento',

    'You can cancel your booking without being charged until': 'Pode cancelar a reserva sem custos até',
    'before the activity takes place': 'antes de a atividade ter lugar.',
    'Enjoy Nature and Have Fun': 'Disfrute da Natureza e divirta-se',
    'Do not forget': 'A não esquecer',
    'Meeting point': 'Ponto de encontro',
    'Price': 'Preço',
    'Deposit': 'Depósito',
    'Payment to the supplier': 'Pagamento ao promotor',
    'Supplier accepted payment methods': 'Formas de pagamento aceites pelo promotor',
    'Print this Voucher': 'Imprima este Voucher',
    'Participants': 'Participantes',
    'Participant': 'Participante',
    'This day is fully booked': 'Este dia tem todas as reservas completas',
    'No bookings waiting for approval': 'Não tem reservas à espera de aprovação',

    'Total Availability': 'Disponibilidade Total',
    'current availability': 'disponibilidade actual',
    'Children between': 'Crianças entre os',
    'and': 'e os',
    'Total availability cannot be bigger than the activity\'s maximum group size': 'Disponíbilidade total não pode ser superior ao valor máximo de participantes definido na página da atividade',
    'Currently': 'Definido como',
    'Available': 'Lugares Disponíveis',
    'Booked': 'Lugares Reservados',
    'Prices': 'Preços',

    'Save profile': 'Guardar Perfil',
    'save password': 'Guardar Password',

    'You must accept the site terms and conditions': 'Tem de aceitar os termos e condições de utilização do site',
    'You have to cancel all bookings for this activity before removing it': 'Tem de cancelar todas as reservas associadas antes de poder apagar esta atividade',

    'Some calendars might need to be reviewed': 'Alguns calendários podem ter de ser revistos',
    'The following calendars could not be automatically updated because they either had bookings, special prices, or a different availability': 'Os calendários a baixo não poderam ser atualizados automáticamente por terem reservas, preços especiais ou uma disponibilidade diferente',
    'There are no more bookings available for this day': 'Já não há reservas disponíveis neste dia',
    'Participant details for insurance purposes': 'Detalhes dos participantes para emissão de seguros',

    'go to Home': 'voltar ao Início',
    'You must provide a country': 'Tem de indicar um país',
    'You must provide a nationality': 'Tem de indicar uma nacionalidade',
    'You must confirm your email account before booking': 'Tem de confirmar a sua conta de email antes de poder fazer uma reserva',
    'You have to answer the supplier\'s question': 'Tem de responder à pergunta do promotor',
    'You must be an approved user to book. Please contact us if you have any questions on your current approval status': 'Tem de ser um utilizador aprovado para fazer reservas. Se tem alguma questão sobre o seu actual estado de aprovação por favor contacte-nos',

    'You current balance': 'O seu saldo actual',
    'You are currently not an accepted user on our site. Please contact us at info@booknatura.com if you need further assistance': 'Neste momento não é um utilizador autorizado no nosso site. Por favor contacte-nos para info@booknatura.com se precisar de assistência',
    'To be charged': 'A pagar',
    'on site': 'no local',
    'validating your card': 'A validar o seu cartão',
    'Credit Card Details': 'Detalhes do Cartão de Crédito',
    'Pay Now': 'Pagar Agora',
    'total': 'total',
    'MMYY': 'MMAA',
    'Card Number': 'Numero de Cartão',
    'Expiration Date': 'Válido até',
    'Invalid card number': 'Número de Cartão inválido',
    'Invalid date. Use MMYY format': 'Data inválida, use o formato MMAA',
    'Invalid CCV number': 'Número de CCV inválido',
    'Transaction refused': 'Transação recusada',
    'MangoPay is not Responding': 'O MangoPay não está a responder',
    'Account is locked or inactive': 'Conta inactiva ou congelada',
    'This card is not active': 'Este Cartão não está activo',
    'Card expired': 'Cartão Expirou',
    'Delay exceeded': 'MangoPay está a demorar demasiado tempo a responder',
    'Unknown Error': 'Erro Desconhecido',
    'You have unpaid bookings': 'Tem reservas não pagas',
    'Go to payments': 'Ir para pagamentos',
    'Outstanding Payments': 'Pagamentos em espera',
    'Thank you for your booking': 'Obrigado pela sua reserva',
    'go to bookings': 'ir para reservas',
    'You will soon receive an email with your booking confirmation': 'Em breve receberá por email a confirmação da sua reserva',
    'You will only be charged after your booking confirmation': 'O valor a pagar apenas será cobrado após receber esta confirmação',
    'Can\'t process payment for this amount. Your card needs to have 3DSecure': 'Não é possivel processar o pagamento para este valor. O seu cartão necessita de 3DSecure',
    'Try again': 'Tentar de novo',

    'Submit all for Approval': 'Enviar todos para aprovação',
    'Remove and send a new document': 'Apagar e enviar um novo documento',
    'Search by regions': 'Procure por regiões',

    'Enjoy  youself while contributing to nature conservation': 'Divirta-se e contribua para a conservação da natureza',
    'Our mission is to bring you on an adventure in a sustainable relationship with nature': 'É nossa missão aproximar as pessoas da natureza, através da divulgação de experiências em áreas naturais de forma sustentável',
    'We promote good environmental practices with the comunity': 'Promovemos boas práticas ambientais junto da comunidade',
    '1% of our profits will be donated to nature conservancy projects': '1% da nossa faturação será doado para projetos de conservação da natureza',
    'Find out more': 'Descubra mais',
    'From date': 'Entre o dia',
    'Until Date': 'e o dia',
    'Search:': 'Pesquisar:',
    'to receive on site': 'a receber no local',
    'total price': 'preço total',
    'deposit price': 'preço do depósito',
    'to be paid on site': 'a pagar no local',
    'go back to activity page': 'voltar para a página de atividade',
    'date': 'data',
    'Last Search...': 'Última Pesquisa...',
    'Booking for': 'Reserva para',
    'Login Required': 'Necessário login',
    'Register if you don\'t have an account yet. Only your name and email are needed for confirmation': 'Se ainda não tem uma conta registe-se. Apenas é necessário o seu nome e email para confirmação.',
    'You don\'t have any bookings yet': 'Ainda não tem reservas',
    'price': 'preço',
    'Waiting for approval': 'À espera de aprovação',
    'activity': 'atividade',
    'client': 'cliente',
    'confirm': 'confirmar',
    'refuse': 'recusar',
    'waiting': 'em espera',
    'confirmed': 'confirmações',
    'unacceped / canceled': 'recusadas / canceladas',
    'refused / canceled': 'recusadas / canceladas',
    'available': 'disponíveis',
    'values': 'valores',
    'tickets': 'lugares',
    'Response to activity question': 'Resposta à questão da atividade',
    'Print this Page': 'Imprimir esta página',
    'Connecting to payment processor': 'A ligar ao processador de pagamentos',
    'Validating your card': 'A validar o seu cartão',
    'Validating transaction': 'A validar a transacção',
    'Events with special features (ex. price, availability)': 'Ocorrências com características distintas (ex: preço, disponibilidade...)',

    'Events with bookings': 'Ocorrências com reservas',
    'You have to cancel the current bookings before canceling this occurrence': 'Tem de cancelar as reservas actuais antes de cancelar este evento',
    'Please explain to the client why you won\'t be able to accept the request. Suggest new dates if applicable.': 'Por favor explique ao cliente o motivo do cancelamento da reserva. Se possível, sugira datas alternativas para a realização da atividade.',
    'Message to Client': 'Mensagem ao Cliente',
    'go back': 'voltar atrás',
    'Justification': 'Justificação',
    'Choose your card': 'Escolha o seu cartão',
    'Cancel': 'Cancelar',
    'Are you sure you want to remove?': 'Tem a certeza que pretende remover?',
    'Cannot Delete Activity': 'Não é possivel remover a atividade',
    'Activity successfully removed': 'Atividade removida com sucesso',
    'Cancel booking for': 'Cancelar reserva para',
    'Booking is still in free cancelation period. If you cancel, your account will not be charged': 'Reserva está no período de cancelamento gratuito. Se cancelar o valor não será cobrado na sua conta.',
    'This booking is no longer in free cancelation period. You\'ll be charged for this activity': 'A reserva já não se encontra no período de cancelamento gratuito. Será cobrado por esta atividade.',
    'close': 'fechar',
    'confirm cancelation': 'confirmar cancelamento',
    'cancel': 'cancelar',
    'expand': 'expandir',
    'to recieve on site': 'a receber no local',
    'cancel booking': 'cancelar reserva',
    'On site': 'No local',
    'Your Bookings': 'As minhas reservas',
    'You don\'t have any scheduled bookings': 'Ainda não tem reservas',
    'Country of Residency': 'País de residência',
    'Birth Date': 'Data de nascimento',
    'Phone Number': 'Número de telefone',
    'Fiscal Number': 'NIF',
    'Your Details': 'Os seus dados',
    'Calendar and Bookings': 'Calendário e Reservas',
    'A question from the supplier': 'Dados pedidos pelo promotor da atividade',
    'Your answer': 'A sua resposta',
    'Waiting for Payment': 'Aguarda Pagamento',
    'There was an error processing your payment. Please sure you set the right card type and details.': 'Ocorreu um erro ao processar o seu pagamento. Assegure-se que insere o tipo de cartão e detalhes corretamente',
    'There was an error processing your payment. Invalid card number.': 'Ocorreu um erro ao processar o seu pagamento. Número de cartão inválido',
    'There was an unknown error processing your payment. Please make sure all card details are correct.': 'Ocorreu um erro desconhecido ao processar o seu pagamento. Por favor confirme que os detalhes do seu cartão estão correctos',
    'Activity was paid in full': 'Atividade foi paga na totalidade',
    'view in google maps': 'Ver no google maps',

    'You don\'t have any payments yet': 'Ainda não tem pagamentos',
    'Processing At': 'A processar em',
    'Value': 'Valor',
    'I want to be a partner': 'Quero ser parceiro',
    'Privacy Policy': 'Política de Privacidade',
    'IBAN is required': 'É necessário o IBAN',
    'BIC is required': 'É necessário o BIC',
    'Validate Bank Account': 'Validar contra bancária',
    'The value is not a valid BIC': 'O valor não é um BIC válido',
    'The value is not a valid IBAN': 'O valor não é um IBAN válido',
    'About Us': 'Sobre Nós',
    'Save and go to Payment Options': 'Guardar e ir para Opções de pagamento',
    'Current Password': 'Password Atual',
    'New Password': 'Nova Password',
    'Confirm New Password': 'Confirmar Nova Password',
    'Save password': 'Guardar password',
    'You still haven\'t confirmed your account. Please check your email for confirmation instructions. If you need further assistance please contact info@booknatura.com': 'Ainda não confirmou a sua conta. Por favor veja o email que lhe enviámos com instruções de confirmação. Se precisar de ajuda contacte-nos através de info@booknatura.com.',
    'It\'s Me': 'Sou Eu',
    'All booking information including promoter data and meeting point are included in your booking confirmation voucher.': 'Todas as informações de reserva incluindo os dados do promotor e o ponto de encontro estão disponíveis no voucher de confirmação de reserva.',
    'The page you were looking for was not found': 'A pagina que procurava não foi encontrada',
    'This activity is not yet publicly visible because is waiting for administrator approval': 'Esta atividade ainda não está vísivel publicamente porque aguarda aprovação do administrador',
    'The promotional code must only contain alphanumeric characters and dashes': 'O código promocional só pode conter caracteres alfanuméricos e traços',
    'Promotional code': 'Código promocional',
    'If you would like some help or advice for your next tour, feel free to contact us.': 'Se precisar de ajuda ou algum conselho para a sua próxima atividade, contacte-nos.',
    'Password': 'Palavra-passe',
    'Repeat Password': 'Repetir Palavra-passe',
    'A username must contain only characters from A-Z 0-9 and dashes': 'O nome de utilizador só pode conter caracteres de A-Z 0-9 e traços',
    'Interview': 'entrevista',
    'Booknatura is a new booking platform for outdoor activities that provide the contact with nature in Portugal': 'A Booknatura é uma nova plataforma de reservas de atividades ao ar livre que proporcionam o contacto com a natureza em Portugal',
    'From jeep tours to scuba diving and dolphin watching: on this new platform you can book everything': 'De passeios de jipe a fazer mergulho e ver golfinhos: nesta nova plataforma pode reservar tudo',
    'Use booknatura.com to find out more about outdoor activities for yourself, friends and family': 'Aproveite a booknatura.com para descobrir mais sobre actividades ao ar livre para si, amigos e família',
    'I did with my husband the Horse Carriage Tour in Alentejo Coast. In addition to the bamboos we had the opportunity to stroll along a stream in a typical Alentejo landscape. Very beautiful landscapes and very friendly and accessible guide. I recommend the tour and the Booknatura service': 'Fiz com o meu marido o passeio de charrete no Litoral Alentejano. Para além dos bambus tivemos oportunidade de passear junto a um riacho numa paisagem tipicamente alentejana. Paisagens muito bonitas e a guia muito simpática e acessível. Recomendo o passeio e o serviço da Booknatura',
    'Booknatura was a nice surprise! Practical, fast, easy and very efficient. I advise everyone who enjoys this type of activities to book through Booknatura. It was a great experience, to repeat!': 'A Booknatura foi uma agradável surpresa! Prático, rápido, fácil e muito eficiente. Aconselho a todas as pessoas que gostem deste tipo de actividades a reservarem por a Booknatura. Foi uma óptima experiência, a repetir!',
  }
};



// WEBPACK FOOTER //
// ./src/translations.js